import React, { useEffect, useRef, useState } from "react";
import { logoutFunction } from "../../_helpers";
import { IoLogOutOutline, IoNotificationsCircleOutline } from "react-icons/io5";
import { MdOutlineMenu } from "react-icons/md";
import { FiUser, FiKey } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/userSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Header({ handleNavbar, moduleName, hasPermanentOpen }) {
  const [openModel, setOpenModel] = useState(false);
  const dispatch = useDispatch();
  const dropDownRef = useRef(null);
  const { user } = useSelector((state) => state.authSlice);
  const location = useLocation();
  const currentPath = location.pathname;
  const [headerTitle, setHeaderTitle] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const formatPathName = (path) => {
      const parts = path.replace(/^\/|\/$/g, "").split("/");
      const lastPart = parts[parts.length - 1];
      const isMongoId = /^[a-fA-F0-9]{24}$/.test(lastPart);
      const isOrderId = /^CUS[0-9]+$/i.test(lastPart);

      const targetPart = isMongoId
        ? parts[parts.length - 2]
        : isOrderId
          ? lastPart
          : lastPart;

      return targetPart
        .replace(/[^a-zA-Z0-9]/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase())
        .trim();
    };

    if (currentPath) {
      const fallbackTitle = formatPathName(currentPath);
      setHeaderTitle(fallbackTitle);
    } else {
      setHeaderTitle(moduleName);
    }
  }, [moduleName, currentPath]);

  const handleLogout = () => {
    logoutFunction();
    dispatch(logout());
  };

  const toggleLogoutModal = () => {
    setOpenModel(!openModel);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setOpenModel(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`${hasPermanentOpen
          ? "bg-white text-black flex flex-shrink-0 h-16 "
          : "fixed top-0 left-0 right-0 flex flex-shrink-0 h-16 bg-white bg-opacity-40 backdrop-blur-sm"
        }  z-20  `}
    >
      <div className="flex items-center justify-between flex-1 px-6 w-full">
        <div
          className={`flex items-center  ${hasPermanentOpen ? "lg:ps-0" : "lg:ps-10 space-x-4"
            }  ps-0`}
        >
          <button
            className="p-2 text-gray-700 rounded-md focus:outline-none md:hidden"
            onClick={handleNavbar}
          >
            <MdOutlineMenu className="w-6 h-6" />
          </button>
          <div>
            <h1 className="text-xl font-semibold text-gray-900 capitalize">
              {" "}
              {headerTitle}
            </h1>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          {user?.data?.role_id !== 6 && (
            <div className="relative">
              {/* Notification Icon */}
              <IoNotificationsCircleOutline
                size={22}
                className="hover:bg-gray-50 hover:w-8 hover:h-8 hover:rounded-full duration-300 transition-all"
                onClick={() => navigate(`/app/notification`)}
              />

              {/* Red Dot Notification Badge */}
              {user?.data?.notification_count > 0 && (
                <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500 animate-ping" />
              )}

              {/* Optional: Add a solid dot behind the ping effect for clarity */}
              {user?.data?.notification_count > 0 && (
                <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500" />
              )}
            </div>
          )}

          <div className="relative">
            <div className="flex gap-2">
              <div>
                <img
                  className="object-contain w-10 h-10 rounded-full cursor-pointer transition-transform hover:scale-105"
                  src={user?.data?.user_image}
                  alt="Profile"
                  onClick={toggleLogoutModal}
                />
              </div>
            </div>
            <div
              className={`absolute right-0 w-64 mt-2 bg-white border border-gray-200 shadow-lg rounded-md transition-all duration-300 ease-in-out ${openModel
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 -translate-y-2 pointer-events-none"
                }`}
              ref={dropDownRef}
            >
              {openModel && (
                <>
                  <div className="px-4 py-3 border-b border-gray-100 flex justify-between items-center gap-3">
                    <img
                      className="object-contain w-12 h-12 rounded cursor-pointer transition-transform hover:scale-105"
                      src={user?.data?.user_image}
                      alt="Profile"
                      onClick={toggleLogoutModal}
                    />

                    <div className="relative group max-w-[160px] cursor-pointer">
                      {/* Name */}
                      <p className="text-sm font-medium text-gray-900 truncate">
                        Hi, {user?.data?.name || user?.data?.userName}
                      </p>

                      {/* Email */}
                      <p className="text-xs text-gray-500 truncate">
                        {user?.data?.email}
                      </p>

                      {/* Tooltip */}
                      <div className="absolute right-full top-1/2 -translate-y-1/2 mr-3 z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none group-hover:pointer-events-auto">

                        <div className="relative bg-gray-900 text-white text-xs rounded px-3 py-2 shadow-lg max-w-xs break-words">
                          <p>{user?.data?.name || user?.data?.userName}</p>
                          <p>{user?.data?.email}</p>

                          {/* Arrow */}
                          <div className="absolute top-1/2 -translate-y-1/2 right-[-6px] w-3 h-3 bg-gray-900 rotate-45"></div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div className="py-1 text-xs px-4">
                    <Link
                      to="/app/profile"
                      className="flex items-center flex-wrap px-3.5 py-2 no-underline text-[rgba(0,0,0,0.85)] rounded font-semibold hover:bg-gray-100 hover:text-blue-600 "
                    >
                      <FiUser className="mr-3" />
                      My Profile
                    </Link>
                    <Link
                      to={`/app/changePassword`}
                      className="flex items-center flex-wrap px-3.5 py-2 no-underline text-[rgba(0,0,0,0.85)] rounded font-medium hover:bg-gray-100 hover:text-blue-600"
                    >
                      <FiKey className="mr-3" />
                      Change Password
                    </Link>
                  </div>

                  <div className="py-1 border-t border-gray-100 text-xs px-4">
                    <p
                      className="flex items-center flex-wrap px-3.5 py-2 no-underline text-[rgba(0,0,0,0.85)] rounded font-medium hover:bg-gray-100 hover:text-blue-600"
                      onClick={handleLogout}
                    >
                      <IoLogOutOutline className="mr-3" />
                      Logout
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
